export default __webpack_public_path__ + "static/media/error.401181c2.svg";